import type { SerializedError } from "@reduxjs/toolkit";
import type { AxiosBaseQueryError } from "./baseQuery";

export function isAxiosBaseQueryError(
  error: unknown
): error is AxiosBaseQueryError {
  return typeof error === "object" && error != null && "meta" in error;
}

export function isAxiosBaseQueryError404(
  error: unknown
): error is AxiosBaseQueryError {
  return isAxiosBaseQueryError(error) && error.status === 404;
}

export function isSerializedError(error: unknown): error is SerializedError {
  return (
    typeof error === "object" &&
    error != null &&
    "message" in error &&
    typeof error.message === "string"
  );
}
